'use strict';

import Alpine from 'shared/js/alpinejs';
import alpineAccessor from './customerSections/alpineAccessor';

alpineAccessor(Alpine);
